export default class hr {
  static translations = {
    views: {
      notFound: {
        pageNotFound: 'Stranica nije pronađena.',
      },
      browserNotSupported: {
        message: 'Vaš Internet preglednik nije podržan.',
      },
    },
    helpers: {
      handle_session_error: {
        loggedOutPrompt: {
          title: 'Prijavili ste se na drugom uređaju?',
          message:
            'Izlogirani ste s ovog uređaja jer ste pristupili sustavu preko drugog uređaja. Jeste li to bili vi?',
        },
        loggedOutAlert: {
          message: 'Vaša prijava je uspješno poslana.',
        },
      },
    },
    components: {
      login: {
        switchDevicePrompt: {
          title: 'Ulogirajte se ovdje?',
          message:
            'Već ste ulogirani na drugom pregledniku. Jeste li sigurni da se želite odjaviti s drugog preglednika i pristupiti putem ovog?',
        },
      },
      documentRename: {
        headline: 'Promjena naziva datoteke',
      },
      eventTabDocuments: {
        status: 'Status',
        private: ' Privatno',
        public: 'Javno',
      },
      eventTabQuestionsAndStatistics: {
        questions: 'Izbori',
        statistics: 'Statistika',
        noQuestionSelected:
          'U trenutku pokretanja izbora, ovdje ćete moći vidjeti i rezultate izbora  ili popis sudionika. Po završetku izbora, biti će Vam dostupni rezultati i popis sudionika i njihovih aktivnosti.',
        errors: {
          questionNotFound: 'Pitanje nije pronađeno na popisu pitanja.',
        },
      },
      eventTabVotersAndCommunication: {
        voters: 'Sudionici',
        communicationEmpty:
          'Ukoliko ste odabrali opciju postavljanja pitanja od strane sudionika, u trenutku pokretanja eventa, odnosno postavljanja pitanja sudionika, ovdje ćete moći vidjeti i moderirati sva pitanja.',
        live: 'Live',
        archive: 'Arhiva',
        questions: 'Pitanja',
      },
      messageList: {
        displayMessage: 'Prikaz pitanja',
      },
      authorizerCreate: {
        validation: {
          name: {
            required: 'Potrebno je upisati naziv.',
            length: 'Naziv može imati maksimalno 191 znakova.',
            unique: 'Naziv mora biti jedinstven.',
          },
        },
      },
      authorizerEdit: {
        validation: {
          name: {
            required: 'Potrebno je upisati naziv.',
            length: 'Naziv može imati maksimalno 191 znakova.',
            unique: 'Naziv mora biti jedinstven.',
          },
        },
      },
      questionCreate: {
        newQuestion: 'Novi izbor',
        validation: {
          quorum: {
            integer: 'Vrijednost mora biti cijeli broj.',
            min: 'Minimalna vrijednost je 1.',
          },
          question: {
            required: 'Potrebno je upisati pitanje.',
            length: 'Pitanje može imati maksimalno 2000 znakova.',
          },
          answers: {
            min: 'Morate upisati barem dva odgovora.',
            required: 'Morate upisati odgovor.',
          },
          minChoices: {
            min: 'Minimalna vrijednost je 1.',
            length: 'Broj odgovora je manji ili jednak upisanoj vrijednosti.',
          },
          maxChoices: {
            min: 'Minimalna vrijednost je 0.',
            length: 'Broj odgovora je manji od upisane vrijednosti.',
          },
        },
      },
      questionEdit: {
        editQuestion: 'Uredi izbor',
        validation: {
          question: {
            required: 'Potrebno je upisati pitanje.',
            length: 'Pitanje može imati maksimalno 2000 znakova.',
          },
          answers: {
            min: 'Morate upisati barem dva odgovora.',
            required: 'Morate upisati odgovor.',
          },
          minChoices: {
            min: 'Minimalna vrijednost je 1.',
            length: 'Broj odgovora je manji ili jednak upisanoj vrijednosti.',
          },
          maxChoices: {
            min: 'Minimalna vrijednost je 0.',
            length: 'Broj odgovora je manji od upisane vrijednosti.',
          },
        },
      },
      authorizerList: {
        errors: {
          authorizerNotFound:
            'Opunomoćitelj nije pronađen na popisu opunomoćitelja.',
        },
      },
      questionList: {
        started: 'Aktivno',
        stopped: 'Zaustavljeno',
        draft: 'Skica',
        startedText: 'Izbor pokrenut u {value}',
        stoppedText: 'Vrijeme trajanja od {from} do {to}',
        verify: {
          startQuestion: 'Jeste li sigurni da želite pokrenuti izbore?',
          stopQuestion: 'Jeste li sigurni da želite zaustaviti izbore?',
        },
        errors: {
          questionNotFound: 'Pitanje nije pronađeno na popisu pitanja.',
        },
      },
      questionStatistics: {
        totalActiveVoters: 'Ukupan broj aktivnih sudionika:',
        quorumRequired: 'Potreban kvorum:',
        theseAreTheResults: 'Ovo su rezultati glasovanja.',
        totalVotes: 'Ukupni broj glasova:',
        noResults: 'Nema rezultata. Nitko nije glasovao.',
        refreshResults: 'Osvježi rezultate',
        voters: 'Sudionici',
        abstentioned: 'Suzdržani',
        notStarted: 'Izbor nije pokrenut te nema rezultata.',
      },
    },
    loginScreen: {
      login: 'Prijava',
      register: 'Registracija',
      forgotPassword: 'Zaboravljena lozinka?',
      reset: 'Resetiraj lozinku',
      back: 'Natrag',
      switchToEnglish: 'Switch to English',
      switchToCroatian: 'Prebaci na hrvatski',
      tfaDescription:
        'Autentifikacijski PIN je poslan SMS porukom na Vaš mobitel. Molimo da ga unesete za nastavak.',
      check: 'Provjeri',
    },
    footer: {
      userManual: 'Upute za korištenje',
      support: 'Podrška',
    },
    toolbar: {
      logout: 'Odjavite se',
    },
    resultsLabels: {
      votingResults: 'Rezultati glasovanja',
      votingDetails: 'Detalji glasovanja',
      currentVotingStatus: 'Trenutni status glasovanja',
      notEnough:
        'Za prikaz rezultata glasovanja potrebno je najmanje 10 glasova.',
      initial_email_fail_hard:
        'Neuspjela isporuka pozivnica za glasovanje (hard)',
      initial_email_fail_soft:
        'Neuspjela isporuka pozivnica za glasovanje (soft)',
      initial_email_delivered: 'Isporučene e-mail pozivnice za glasovanje',
      initial_email_sent: 'Pozivnice koje su poslane glasaču',
      initial_email_read: 'Pozivnice koje su pročitane',
      vote_link_opened: 'Glasači koji su otvorili poveznicu za glasovanje',
      sms_sent: 'Glasači koji su zatražili PIN putem SMS-a',
      sms_recieved: 'Glasači koji su dobili PIN putem SMS-a',
      pin_checked_true: 'Glasači koji su unijeli točan PIN',
      pin_checked_false: 'Glasači koji su unijeli krivi PIN',
      voted: 'Glasači koji su glasovali',
      sms_rejected: 'Glasači kojima je SMS obijen',
      active_voters: 'Aktivni broj glasača',
    },
    titles: {
      results: 'Rezultati',
    },
    fields: {
      authorizers: 'Opunomoćitelji',
      event_quorum_value: 'Vrijednost',
      search: 'Traži',
      name: 'Ime',
      name_and_surname: 'Ime i prezime',
      event_name: 'Interni naziv eventa',
      surname: 'Prezime',
      email: 'E-mail',
      mobile: 'Broj telefona',
      password: 'Lozinka',
      start: 'Početak',
      end: 'Kraj',
      start_date: 'Datum početka eventa',
      end_date: 'Datum završetka eventa',
      start_time: 'Vrijeme početka eventa',
      end_time: 'Vrijeme završetka eventa',
      status: 'Status',
      option: 'Opcija',
      addOption: 'Upišite ponuđeni odgovor ili ostavite prazno',
      new_option: 'Nova opcija',
      voters: 'Glasači',
      header: 'Zaglavlje glasačkog listića',
      footer: 'Podnožje glasačkog listića',
      intro: 'Uvod',
      introTitle: 'Naslov e-mail pozivnice sudionicima',
      intro_text: 'Sadržaj e-mail pozivnice sudionicima (SLOBODNI UNOS)',
      reminder_title: 'Naslov',
      reminder_text: 'Tekst podsjetnika',
      help_contact: 'E-mail organizatora za podršku',
      question: 'Pitanje',
      event_title: 'Naziv eventa',
      time: 'Vrijeme',
      step: 'Korak',
      maximum_choices: 'Najveći broj mogućih odgovora',
      minimum_choices: 'Najmanji broj mogućih odgovora',
      old_password: 'Stara lozinka',
      new_password_1: 'Nova lozinka',
      new_password_2: 'Ponovite novu lozinku',
      eventTags: 'Interne oznake za kategorizaciju evenata',
      tags: 'Interne oznake',
      event: 'Eventi',
      phone: 'Telefon',
      subject: 'Naslov',
      message: 'Poruka',
      clientName: 'Naziv',
      address: 'Adresa',
      city: 'Grad',
      country: 'Država',
      oib: 'OIB',
      contact_person: 'Kontakt osoba',
      contact_email: 'Kontakt e-mail',
      allowed_domains: 'Dopuštene domene',
      eventType: 'Vrsta izbora',
      weight: 'Težina',
      tokensPro: 'Tokeni',
      tokens2fa: '2fa Tokeni',
      pin: 'PIN',
      tfaEnabled: 'Uključeno',
      voted: 'Glasovao',
      authorizer: 'Opunomoćitelj',
    },
    tabs: {
      general: 'Osnovni podaci',
      ballot: 'Sudionici',
      communication: 'Komunikacija',
      results: 'Rezultati',
      log: 'Zapisi aktivnosti',
      voters: 'Izbori i statistika',
      messages: 'Pozivnice',
      emailInvitation: 'E-mail pozivnica',
      emailReminder: 'E-mail podsjetnik',
      emailSupport: 'Podrška glasačima',
      options: 'Dokumenti',
      publish: 'Objavi',
      test: 'Agenda',
    },
    modules: {
      dashboard: 'Naslovnica',
      voterGroups: 'Grupa glasača',
      events: 'Eventi',
      event: 'Event',
      settings: 'Postavke',
      upgrade: 'Nadogradite račun',
      newEvent: 'Novi event',
    },
    dataTable: {
      rowsPerPage: 'Redovi po stranicama:',
      results: 'Rezultati',
      of: 'od',
      search: 'Traži',
      all: 'Sve',
    },
    alerts: {
      eventTypeTransparent:
        'Odabirom ove opcije glasovanje neće biti anonimno.',
      quorumValueEmpty: 'Morate upisati vrijednost kvoruma.',
      quorumValueNotInteger: 'Vrijednost kvoruma mora biti cijeli broj',
      quorumValueMin: 'Minimalna vrijednost kvoruma je 1.',
      maxFileSizeLimit: 'Ne možete unijeti više od 8MB po datoteci.',
      refreshPage: 'Osvježite stranicu?',
      closeQuestionCreate:
        'Jeste li sigurni da želite napustiti kreiranje izbora bez spremanja?',
      startEvent:
        'Jeste li sigurni da želite pokrenuti ovaj event. Jednom pokrenut event moguće je samo zaustaviti, ali ne i ponovo pokrenuti.',
      stopEvent:
        'Jeste li sigurni da želite zaustaviti ovaj event. Jednom zaustavljen event moguće je samo zaustaviti, ali ne i ponovo pokrenuti',
      resendSingleQuestion: 'Želite li poslati e-mail glasaču?',
      resendQuestion: 'Želite li sigurno poslati ponovno e-mail glasaču?',
      optionDeletionQuestion: 'Jeste li sigurni da želite obrisati ovu opciju?',
      questionDeletionQuestion:
        'Jeste li sigurni da želite obrisati ovo pitanje?',
      voterDeletionQuestion:
        ' Jeste li sigurni da želite obrisati ovog glasača?',
      deletionQuestion: 'Jeste li sigurni da želite obrisati ovaj zapis?',
      deletionQuestionAdditional:
        'Jeste li sasvim sigurni da želite izbrisati ovaj zapis?',
      cloneQuestion: 'Jeste li sigurni da želite duplicirati ovaj zapis?',
      archiveQuestion: 'Jeste li sigurni da želite arhivirati ovaj zapis?',
      nameMissing: 'Niste upisali naziv eventa.',
      firstnameMissing: 'Niste upisali ime.',
      nameTooLong: 'Naziv ne smije biti duži od 40 znakova.',
      reminderTitleTooLong:
        'Naslov podsjetnika ne smije biti duži od 50 znakova.',
      nameLength: 'Ime mora imati najmanje dva znaka.',
      surnameMissing: 'Niste upisali prezime.',
      surnameLength: 'Prezime mora imati najmanje dva znaka.',
      mobileMissing: 'Niste upisali broj mobitela.',
      mobileFailFormat: 'Broj mobitela je u krivom formatu.',
      phoneMissing: 'Niste upisali broj telefona.',
      phoneFailFormat: 'Broj telefona je u krivom formatu.',
      emailMissing: 'Niste upisali e-mail.',
      emailVerification: 'E-mail nije valjan.',
      email1Verification: 'E-mail 1 nije valjan.',
      email2Verification: 'E-mail 2 nije valjan.',
      email3Verification: 'E-mail 3 nije valjan.',
      emailDomain: 'E-mail domena nije odobrena.',
      passwordMissing: 'Niste upisali lozinku.',
      passwordSpaces: 'Lozinka ne smije sadržavati razmake.',
      startDateMissing: 'Niste izabrali datum početka.',
      startTimeMissing: 'Niste izabrali vrijeme početka.',
      startTimeVerification: 'Vrijeme početka nije valjano',
      endDateMissing: 'Niste izabrali datum završetka.',
      endTimeMissing: 'Niste izabrali vrijeme završetka.',
      endTimeVerification: 'Vrijeme završetka nije valjano.',
      helpContactMissing: 'Niste upisali e-mail za podršku glasačima.',
      helpContactFormat: 'E-mail za podršku nije ispravan.',
      votersMissing: 'Niste izabrali glasače.',
      questionsMissing: 'Niste upisali niti jedno pitanje.',
      questionsDuplicate: 'Upisali ste neko pitanje dva puta.',
      questionEmpty: 'Imate pitanje bez teksta.',
      optionsDuplicate: 'Dvaput ste unijeli istu opciju unutar jednog pitanja.',
      optionEmpty: 'Postoji odgovor koji je prazan.',
      notEnoughOptions: 'Svako pitanje mora imati barem dvije mogućnosti.',
      tooManyOptionsMax:
        'Postoji pitanje kojemu je broj opcija manji od maksimalnog broja odabira.',
      tooManyOptionsMin:
        'Postoji pitanje kojemu je broj opcija manji ili jednak minimalnom broju odabira.',
      maxZero: 'Maksimalan broj odabira ne smije biti nula.',
      minZero: 'Minimalan broj odabira ne smije biti nula.',
      headerMissing: 'Niste unijeli zaglavlje.',
      footerMissing: 'Niste unijeli podnožje.',
      introMailMissing:
        'Niste unijeli sadržaj e-maila pozivnice za glasovanje.',
      introMailTitleMissing:
        'Niste unijeli naslov e-maila pozivnice za glasovanje.',
      introMailTitleTooLong:
        'Naslov e-maila pozivnice za glasovanje ne može biti duži od 180 znakova.',
      reminderMailMissing:
        'Niste unijeli sadržaj e-maila podsjetnika za glasovanje.',
      reminderMailTitleMissing:
        'Niste unijeli naslov e-maila podsjetnika za glasovanje.',
      wrongCredentials: 'Unijeli ste krive korisničke podatke.',
      noData: 'Nema podataka',
      noResults: 'Nema rezultata.',
      voterExists: 'Glasač s tim e-mailom ili mobitelom već postoji.',
      failed: 'Neuspjelo: ',
      added: 'Dodano: ',
      newOptionEnter: 'Pritisnite enter za dodavanje nove opcije.',
      eventStatusFail:
        'Status je nevažeći. Samo statusi "Skica" i "Objavljeno" se mogu postaviti ručno.',
      eventSmsFail: 'Postoji osoba kojoj nije unesen broj telefona.',
      leaveQuestion:
        'Jeste li sigurni da želite napustiti ovaj zaslon bez spremanja?',
      eventMissing: 'Eventi moraju biti odabrani.',
      publishWarning:
        'Molimo da prije pokretanja izbora provjerite stanje tokena. Ukoliko nemate dovoljno tokena izbori odnosno pitanje se neće moći pokrenuti.',
      publishQuestion: 'Jeste li sigurni da želite objaviti event?',
      passwordResetSuccess: 'Molimo Vas, provjerite svoj e-mail.',
      passwordResetFail: 'Korisnik s tom e-mail adresom ne postoji.',
      newPasswordMissing: 'Niste upisali novu lozinku',
      passwordMatch: 'Nove lozinke se ne podudaraju.',
      passwordLength: 'Nova lozinka mora imati najmanje 8 znakova.',
      newPasswordOldPasswordMatch:
        'Nova i stara lozinka moraju biti različite.',
      passwordChangeSuccess: 'Vaša lozinka je promijenjena.',
      passwordChangeError: 'Vaša stara lozinka je pogrešna.',
      timesWrong:
        ' Vrijeme završetka glasovanja mora biti nakon vremena početka glasovanja.',
      automaticReminderWrong:
        'Broj dana za automatske podsjetnike mora biti kraći od trajanja eventa.',
      automaticReminderZero:
        'Broj dana za automatske podsjetnike ne smije biti 0.',
      noVoters: 'Nema dodanih glasača za ovaj event.',
      startTimeInThePast: 'Vrijeme početka ne može biti u prošlosti',
      maximumEmailsSent:
        'E-mail se ne može poslati. Maksimalan broj e-mailova već je poslan ovom glasaču.',
      logoutConfirmation: 'Jeste li sigurni da se želite odjaviti?',
      userDisabled:
        'Vaš korisnički račun je zaključan jer ste više od 3 puta unijeli krivi pin. Za otključavanje korisničkog računa kliknite na poveznicu koja Vam je poslana na Vašu e-mail adresu.',
      votersClearQuestion: 'Jeste li sigurni da želite ukloniti sve glasače?',
      invalidImport: 'Polja nisu ispravno upisana.',
      fileDeletionQuestion: 'Jeste li sigurni da želite ukloniti ovu datoteku?',
      nameSurnameMissing: 'Niste unjeli ime i prezime.',
      subjectMissing: 'Niste unjeli naslov.',
      messageMissing: 'Niste unjeli poruku.',
      supportSuccess: 'Poruka je poslana.',
      eventTooLong: 'Maksimalno trajanje eventa je 1 mjesec.',
      eventNoVoters: 'Za odabrane eventa nisu uneseni glasači',
      domainsError:
        'Ne možete napraviti ovu promjenu na domenama jer postoji glasač koji ne odgovara novim postavkama.',
      voterDeactivationQuestion:
        'Jeste li sigurni da želite deaktivirati korisnika?',
      deactivationVoterVoted:
        'Glasača nije moguće deaktivirati jer je već glasovao.',
      excelNoVoters: 'Nema glasača u listi.',
      testEmailsMissing: 'Niste unjeli niti jednu adresu.',
      pinMatch: 'Niste upisali ispravne brojeve.',
      purchase: 'Vaša narudžba se obrađuje. Uskoro ćemo Vas konktatirati.',
      tokensNotAvailable:
        'Nemate dovoljno raspoloživih tokena. Za aktivaciju dodatnih tokena, javite se na info@fair-votes.com.',
      tfaPopup:
        'Predlažemo da u postavkama uključite dvofaktornu autentifikaciju za Vaš korisnički račun.',
      savedPopup: 'Promjene spremljene.',
      emailVotedError:
        'Ne možete poslati podsjetnik ovom glasaču jer je glasovao.',
      pageRefreshed: 'Stranica osvježena',
      testSent: 'Pozivnice poslane.',
      invalidWeight: 'Težina ne smije biti 0.',
      removeEmailsFirst:
        'Molimo uklonite glasače prije odabira dopuštene domene.',
      tokenPurchaseRequestQuestion:
        'Jeste li sigurni da želite poslati zahtjev?',
      clientExpired: "Vaš korisnički račun je istekao.",
    },
    buttons: {
      back: 'Natrag',
      archive: 'Arhiviraj',
      clone: 'Dupliciraj',
      preview: 'Pretpregled listića',
      new: 'Novo',
      createNew: 'Kreiraj nove evente',
      save: 'Spremi',
      cancel: 'Poništi',
      yes: 'Da',
      no: 'Ne',
      ok: 'OK',
      delete: 'Izbriši',
      edit: 'Uredi',
      addQuestion: 'Dodaj pitanje',
      passwordSet: 'Postavi lozinku',
      passwordChange: 'Promijeni lozinku',
      next: 'Dalje',
      all: 'Sve',
      completed: 'Završeni',
      active: 'Aktivni',
      published: 'Objavljeni',
      drafts: 'Skice',
      editInfo:
        'Dodatne informacije o odgovoru pojavit će se na glasačkom listiću kao kratak opis uz odgovor',
      addVoter: 'Dodaj glasača',
      loadVoters: 'Uvezite glasače s drugih evenata',
      importVoters: 'Uvezite glasače iz Excel tablice',
      downloadTemplate: 'Preuzmi predložak',
      downloadVoters: 'Preuzmite listu',
      resendEmail: 'Pošaljite E-mail glasačima koji nisu glasovali.',
      sendEmailVoter: 'Pošalji e-mail glasaču',
      publish: 'Objavi',
      moveUp: 'Promjena redoslijeda pitanja',
      moveDown: 'Promjena redoslijeda pitanja',
      nextStep: 'Sljedeći korak',
      loadLog: 'Učitaj podatke',
      refreshLog: 'Osvježi podatke',
      loadData: 'Uvezi s drugih evenata',
      loadBallot: 'Uvezi glasački listić s drugih evenata',
      voterHistory: 'Pokaži povijest postupaka ovog glasača',
      sendSms: 'Pošalji SMS',
      send: 'Pošalji',
      close: 'Zatvori',
      saveDraft: 'Spremi kao skicu',
      deactivate: 'Deaktiviraj',
      test: 'Testiraj',
      refresh: 'Refresh',
      pdf: 'PDF',
      buy: 'Kupi',
    },
    labels: {
      enableAudioVideo: 'Omogući Audio/Video',
      voterUiType: 'Način rada',
      voterUiTypeBasic: 'Osnovni',
      voterUiTypeAdvanced: 'Napredni',
      eventType: 'Vrsta izbora',
      anonymous: 'Anonimno',
      transparent: 'Transparentno',
      addOptionEnter: 'Dodaj s "Enter"',
      multiple_choices_enabled: 'Dopustiti više odgovora za ovo pitanje',
      maximumChoices: 'Koristi 0 za neograničeno.',
      noResultsEvents: 'U ovom trenutku nema aktivnih evenata.',
      noResultsEventsDetails:
        'Za objavu novog eventa potrebno je popuniti sva obavezna polja. Nakon što su eventi gotovi, možete ih deaktivirati ili po potrebi izbrisati. Izbrisani eventi više neće biti dostupni. Za detaljne upute o korištenju FairVotes.LIVE platforme kliknite na "Pomoć" na vrhu ekrana.',
      noResultsEventsFilter: 'Nema eventa u ovoj kategoriji.',
      noResultsEventsSearch: 'Nema rezultata pretraživanja.',
      singleAuthentication:
        'Putem e-mail adrese sudionika - jednostavna autorizacija',
      doubleAuthentication:
        'Putem e-mail adrese sudionika i broja mobitela sudionika (SMS) - dvofaktorska autorizacija',
      showResults: 'Prikaži rezultate izbora',
      eventLanguage: 'Jezik',
      results_in_progress_1:
        'Tijekom glasačkog razdoblja  - nije vidljivo je li pojedini sudionik glasovao',
      results_in_progress_2:
        'Nakon glasačkog razdoblja - vidljivo je je li pojedini sudionik glasovao',
      automatic_reminders_1:
        ' Pošalji e-mail podsjetnik za glasače koji nisu glasovali svakih ',
      automatic_reminders_2: ' dana',
      abstention: 'Dopusti suzdržanost glasača za ovo pitanje',
      manual_reminders:
        'Dopusti ručno slanje e-maila s pozivom na glasanje tijekom glasačkog perioda',
      adding_voters_in_progress:
        'Dopusti dodavanje glasača tijekom trajanja eventa',
      alreadySent: 'Već poslano',
      smsSent: 'SMS poruka je poslana glasaču',
      unsubscribed: 'Ovaj glasač se odjavio.',
      helpContactInfo: 'Korisnička podrška za evente.',
      optionDescription: 'Opis odgovora',
      accountUpgrade: 'Nadogradite<br />račun',
      publishText:
        'Kada su sva potrebna polja ispunjena, provjerena i potvrđena od strane organizatora, kliknite na gumb "Objavi". Jednom kada su eventi objavljeni, nije ih moguće uređivati niti brisati sve do završetka eventa.',
      testText:
        'Kada su sva potrebna polja ispunjena, provjerena i potvrđena od strane organizatora, kliknite na gumb "Testiraj", kako biste obavili testiranje.<br />Na mail ćete dobiti pozivnicu i link za glasački listić (testiranje je moguće u obliku jednostavne autorizacije).',
      search: 'Pretraga po nazivu ili oznaci',
      dropdownNoData: 'Trenutno nema podataka.',
      editVoter: 'Uredi glasača',
      addVoter: 'Dodaj glasača',
      randomizeOptions:
        'Nasumično razvrstaj (randomiziraj) prikaz odgovora glasaču',
      identityConfirmation: 'Potvrda identiteta sudionika',
      editInfoTitle: 'Dodatne informacije o odgovoru',
      mobileHint: '+385xxxxxxxxx ili 09xxxxxxxx',
      appLanguage: 'Odaberite jezik aplikacije',
      changePassword: 'Promijenite lozinku',
      emailRecieved: 'Primio mail',
      emailOpened: 'Otvorio mail',
      linkClicked: 'Kliknuo na link',
      all: 'Svi',
      supportTitle: 'Podrška',
      supportText: 'Unesite Vaš upit, prijavu poteškoće ili prijedlog.',
      uploadInProgress: 'Upload u tijeku.',
      attachmentPhoto: 'Prilog (fotografija)',
      licenseDetails: 'Podaci o licenci',
      unlockText:
        'Vaš korisnički račun je otključan. Na e-mail adresu ćete zaprimiti novu lozinku za ulazak u sustav.',
      answer: 'Odgovor',
      allowAllDomains: 'Dozvoli sve domene',
      archive: 'Arhiva',
      voted: 'Glasao',
      inactive: 'Neaktivan',
      domainExplanation:
        'Za dodavanje dopuštenih domena upišite domenu i kliknite enter.',
      allow_unsubscriptions:
        'Dopusti glasaču da se odjavi s liste za slanje podsjetnika za glasovanje',
      eventTypeClassic: 'Standardno glasovanje - 1 sudionik = 1 glas',
      eventTypeWeighted:
        'Težinsko glasovanje - 1 sudionik = ovisno o  važnosti glasa sudionika',
      testDialogTitle: 'Unesite adrese za testiranje',
      deleteDialog:
        'Jeste li sigurni da želite obrisati ovo glasovanje? Glasovanje se trajno briše i nije ga moguće vratiti.<br />Ako želite obrisati, molimo upišite sljedeće brojeve:<br /><br />',
      sendPdf: 'Automatsko slanje rezultata na mail sudionika',
      tokensTitle: 'Raspoloživi Tokeni',
      tokensPlayground: 'Raspoloživi playground Tokeni:',
      tokensPro: 'Raspoloživi Tokeni:',
      tokens2fa: 'Raspoloživi 2fa Tokeni:',
      tokensExplanation:
        'Prilikom otvaranja korisničkog računa dobivate 50 besplatnih Tokena za pokretanje glasovanja sa jednostavnom autorizacijom. S besplatnim Tokenima nije moguća 2faktorska autorizacija (SMS).',
      tokensFormTitle: 'Kupi Tokene',
      piece: 'kom',
      emailBounce: 'E-mail nije moguće dostaviti',
      smsBounce: 'SMS nije moguće dostaviti',
      tfa: 'Dvofaktorna autentifikacija',
      allowed_domains: 'Dopuštene domene',
      yes: 'Da',
      no: 'Ne',
      enable_live_questions: 'Live pitanja sudionika',
      live_questions_visibility: 'Vidljivost pitanja',
      live_questions_visibility_organizer: 'Organizatoru',
      live_questions_visibility_organizer_and_voters:
        'Organizatoru i sudionicima',
      warmup_message:
        'Sadržaj koji se prikazuje sudionicima prije nego se pokrenu izbori',
      technical_details_text:
        'Sadržaj email pozivnice sudionicima (TEHNIČKE UPUTE)',
      agenda: 'Upišite agendu svog eventa',
      logo_upload: 'Logo upload',
      document_upload: 'Dodaj dokument',
      quorum: 'Kvorum',
      tokenExplanationGeneralTitle: 'Objašnjenje korištenje Tokena',
      tokenExplanationGeneralPerEvent:
        'pokretanje izbora = Token * (broj glasača/opunomoćenika)',
      tokenExplanationGeneralPerQuestion:
        'pokretanje svakog pitanja = Token * (broj glasača/opunomoćenika)',
      tokenExplanationGeneral2fa:
        '2fa Tokeni potrebni su samo za pokretanje izbora, ne i za pokretanje pitanja.',
      tokenExplanationAuthorizersTitle:
        'Dodatno objašnjenje korištenja Tokena za opunomoćenike',
      tokenExplanationAuthorizersZero: 'glasač bez opunomoćenika = 1 Token',
      tokenExplanationAuthorizersOne: 'glasač s 1 opunomoćenikom = 1 Token',
      tokenExplanationAuthorizersTwo: 'glasač s 2 opunomoćenika = 2 Tokena',
      tokenExplanationAuthorizersN: 'glasač s n opunomoćenika = n Tokena',
    },
    importLabels: {
      totalRecords: '<b>Ukupan broj zapisa: </b>',
      importedRecords: '<b>Broj uvezenih zapisa: </b>',
      emptyEmail: '<b>Broj zapisa bez e-mail adrese: </b>',
      domainEmail: '<b>Broj zapisa sa nedozvoljenom domenom: </b>',
      failedEmail: '<b>Broj zapisa s e-mail adresama koje nisu ispravne: </b>',
      failedMobile: '<b>Broj zapisa s brojem mobitela koji nije ispravan: </b>',
      duplicates: '<b>Broj duplih zapisa (e-mail ili mobitel): </b>',
    },
    languages: {
      en: 'Engleski',
      hr: 'Hrvatski',
      sl: 'Slovenski',
    },
    ballot: {
      footer:
        'FairVotes.LIVE je elektronički sustav za glasovanje, razvijen od strane IDE3 d.o.o.. Sva prava pridržana.',
      wrongTokenPreview: 'Poštovani, traženi link nije aktivan.',
      wrongTokenVote:
        'Ovaj stranica više nije aktivna. Vaš glas je već zabilježen ili je period glasovanja završio.',
      previewAlert:
        'Ovo je samo preview glasačkog listića. Glas ne može biti zabilježen.',
      step1:
        'FairVotes.LIVE glasovanje: %title%<br />Organizator: %client%<br />Rok za glasovanje: %end%<br /><br />Poštovani,<br/><br />molimo da pripremite svoj mobitel kako biste se autorizirali za glasovanje.<br /><br />Autorizacijski PIN će biti poslan SMS porukom na Vaš mobitel (prijavljeni broj završava sa <b>***%phone_number%</b>). Autorizacijski PIN aktivan je 2 sata od zaprimanja.<br /><br />Za dodatna pitanja molimo obratite se administratoru glasovanja na %help_contact%.',
      step2:
        'Poštovani,<br/><br/>Molimo unesite PIN koji je poslan putem SMS-a na Vaš mobitel (prijavljeni broj završava sa <b>***%phone_number%</b>).<br/><br/>Ako niste zaprimili poruku molimo kliknite niže za ponovno slanje.',
      btnAuthenticate: 'AUTORIZIRAJ SE',
      btnPinProblem: 'NISTE ZAPRIMILI SMS ILI JE PIN ISTEKAO?',
      completed: 'Poštovani, mogućnost glasovanja za ovu temu je završeno.',
      voteCasted: 'Poštovani, Vaš glas je zabilježen.',
      pinAlert:
        'Pin je zatražen previše puta. Javite se organizatoru na adresu',
      pinFail: 'Uneseni PIN nije ispravan ili je istekao.',
      oneOption: 'potrebno je odabrati jednu opciju',
      multipleOptionsA_1: 'potrebno je odabrati',
      multipleOptionsA_2: 'opcije',
      multipleOptionsB_1: 'potrebno je odabrati od',
      multipleOptionsB_2: 'do',
      multipleOptionsB_3: 'opcije',
      abstent: 'Suzdržan/a',
      btnVote: 'Glasaj',
      abstentionLock: 'Ne možete izabrati odgovor ako ste suzdržani.',
      wrongNumberOfOptions: 'Neispravan broj odabranih opcija.',
      unsubscribeSuccess: 'Uspješno ste odjavljeni.',
      unsubscribeQuestion:
        'Jeste li sigurni da se želite odjaviti s liste za online glasovanje',
      expired: 'Ne možete glasati jer je glasanje završeno.',
      wrongSession:
        'Link za glasovanje već je otvoren na drugom uređaju. Molimo zatvorite ranije otvoreni link ili ponovno otvorite link za glasovanje za 5 minuta.',
    },
    statuses: {
      draft: 'Skica',
      published: 'Objavljeno',
      active: 'Aktivno',
      completed: 'Završeno',
      archive: 'Arhivirano',
    },
    filters: {
      active: 'Aktivan',
      sms: 'SMS',
      status: 'Status',
      helpFilter: 'Help filter',
      help: 'Help',
      active1: 'Aktivni',
      active0: 'Deaktivirani',
      sms0: '0 zatraženih PIN-ova',
      sms1: '1 zatražen PIN',
      sms2: '2 zatražena PIN-a',
      sms3: '3 zatražena PIN-a',
      sms4: 'više od 3 zatražena PIN-a',
      emailSent1: 'E-mail poslan',
      emailSent0: 'E-mail nije poslan',
      emailReceived1: 'Primio e-mail',
      emailReceived0: 'Nije primio e-mail',
      emailOpened1: 'E-mail otvoren',
      emailOpened0: 'E-mail nije otvoren',
      linkOpened1: 'Link za glasanje otvoren',
      linkOpened0: 'Link za glasanje nije otvoren',
      pinRequested1: 'PIN je zatražen',
      pinRequested0: 'PIN nije zatražen',
      pinReceived1: 'Dobio PIN',
      pinReceived0: 'Nije dobio PIN',
      voted1: 'Glasovao',
      voted0: 'Nije glasovao',
      voterOnline1: 'Sudionik prisutan',
      voterOnline0: 'Sudionik nije prisutan',
    },
    tooltips: {
      downloadEventPdf: 'Preuzmite PDF za rezultatima',
      newEvent: 'Kreiraj novi event',
      loadBallot:
        'Popuni polja zaglavlja, naslova, podnožja i pitanja iz drugih evenata',
      addQuestion: 'Dodaj pitanje na listić',
      addVoter: 'Dodaj glasača na listu glasača',
      loadVoters: 'Uvezite postojeću listu glasača sa drugih evenata',
      importVoters: 'Uvoz liste glasača iz popunjenog Excel predloška',
      downloadTemplate:
        'Preuzmite Excel predložak za potrebe uvoza liste glasača',
      downloadVoters: 'Preuzmite tablicu glasača',
      loadEmailData:
        'Popuni polja email naslova, teksta i email adresse sa podacima iz drugih evenata',
      publish: 'Objavi glasovanje',
      back: 'Natrag na popis evenata',
      save: 'Spremi event',
      nextStep: 'Pređi na sljedeći korak',
      edit: 'Uredi odabrane evente',
      preview: 'Pretpregled izgleda glasačkog listića na ekranu',
      clone: 'Dupliciraj',
      delete: 'Obriši odabrane evente',
      archive: 'Premjesti odabrane evente u arhivu',
      clearVoters: 'Isprazni listu glasača',
      resultsInProgress:
        'Preporučamo korištenje opcije prikaza rezultata "Nakon završetka glasovanja" zbog transparentnosti i uklanjanja mogućnosti utjecanja na glasače temeljem trenutnih rezultata',
      saveDraft: 'Spremi kao skicu',
      test: 'Testiraj',
      audioVideoTooltip:
        'Za promjenu Audio/Video opcije kontaktirajte svog administratora',
      questionAnonymity:
        'Ukoliko se ne odabere, anonimnost pitanja ovisit će o postavkama izbora',
    },
  }
}
